import React from "react";
import { Grid, Typography, Box } from "@mui/material";
import { SUPPORTED_LANGUAGES, getPlaceholder } from "./constants";
import { translate } from "../../../../../../../common/providers";
import styles from "./LanguageFields.module.css";
import { CustomTextField } from "../../../../../../../common/components";

export default function LanguageFields({ fieldName, fieldType = "text", maxLength, rows = 1, metadata, onChange }) {
	return (
		<Box className={styles.languageFieldsContainer}>
			<Grid container spacing={1.5}>
				{SUPPORTED_LANGUAGES.map((lang) => (
					<Grid key={lang.code} item sm={4} xs={12}>
						<Typography className={styles.languageLabel} color="textSecondary" variant="caption">
							{translate(lang.labelKey)}
						</Typography>
						<CustomTextField
							fullWidth
							data-multiline={fieldType === "multiline" ? "true" : "false"}
							inputProps={{ maxLength }}
							multiline={fieldType === "multiline"}
							placeholder={getPlaceholder(fieldName, lang.code)}
							rows={rows}
							size="small"
							value={metadata[lang.code][fieldName]}
							variant="outlined"
							onChange={(e) => onChange(lang.code, fieldName, e.target.value)}
						/>
					</Grid>
				))}
			</Grid>
		</Box>
	);
}
